export default __webpack_public_path__ + "static/flutterwave-e648ddce12520bf433b7c9673e8fc793.png";